// src/components/table/OcrHeaderBlock.jsx
import React from "react";

export default function OcrHeaderBlock({
  label,
  hoverKey,
  sortIndex,
  percentIndex,
  hoveredColumn,
  setHoveredColumn,
  setSortColumn,
  th,
  divider,
}) {
  return (
    <>
      <th style={{ ...th, ...divider }}>{label} Close</th>

      {/* GREEN % header */}
      <th
        data-tooltip="Click to sort by lowest %"
        className={`sortable-header percent-header ${hoveredColumn === hoverKey ? "hovered" : ""}`}
        style={{
          ...th,
          position: "sticky",
          top: 0,
          background: "#d1fae5",
          zIndex: 999,
          cursor: "pointer",
        }}
        onClick={() => setSortColumn(percentIndex)}
        onMouseEnter={() => setHoveredColumn(hoverKey)}
        onMouseLeave={() => setHoveredColumn(null)}
      >
        {label} %
      </th>

      {/* PURPLE OCR header + 9 empty cells */}
      {[...Array(10)].map((_, i) =>
        i === 0 ? (
          <th
            key={i}
            data-tooltip="Click to sort by lowest OCR"
            className={`sortable-header ${hoveredColumn === hoverKey ? "hovered" : ""}`}
            style={{
              ...th,
              ...divider,
              position: "sticky",
              top: 0,
              background: "#e6ccff",
              zIndex: 999,
              cursor: "pointer",
            }}
            onClick={() => setSortColumn(sortIndex)}
            onMouseEnter={() => setHoveredColumn(hoverKey)}
            onMouseLeave={() => setHoveredColumn(null)}
          >
            {label} Candles
          </th>
        ) : (
          <th key={i} style={th}></th>
        )
      )}
    </>
  );
}
